










import { Component, Vue } from 'vue-property-decorator';
import Menu from './components/Menu.vue';
import Header from '@/components/Header.vue';
import Products from '@/components/Products.vue';
import Contact from '@/components/Contact.vue';
import Footer from '@/components/Footer.vue';

@Component({
  components: {
    Footer,
    Contact,
    Products,
    Header,
    Menu
  }
})
export default class App extends Vue {
  mounted() {
    document.querySelectorAll('a[href^="#"]').forEach((anchor: Element) => {
      anchor.addEventListener('click', e => {
        e.preventDefault();

        const link = anchor.getAttribute('href');

        if (link) {
          document.querySelector(link)?.scrollIntoView({
            behavior: 'smooth'
          });
        }
      });
    });
  }
}
